import { createContext, createElement, useCallback, useContext, useMemo, useState } from "react";
import { toast } from "sonner";
import { clearCache, imgUrl, useFetch } from "./api";
import { track } from "./analytics";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [nonce, setNonce] = useState(0);
  const settings = useFetch("/settings", nonce);
  const categories = useFetch("/categories", nonce);
  const reload = useCallback(() => {
    clearCache();
    setNonce((n) => n + 1);
  }, []);
  const value = useMemo(() => {
    const cats = categories.data || [];
    return {
      settings: settings.data,
      categories: cats,
      catById: Object.fromEntries(cats.map((c) => [c.id, c])),
      loading: settings.loading || categories.loading,
      error: settings.error || categories.error,
      reload,
    };
  }, [settings, categories, reload]);
  return createElement(SiteContext.Provider, { value }, children);
}

export const useSite = () => useContext(SiteContext);

export const openResume = (settings) => {
  track("resume_download", { available: !!settings?.resume_url });
  if (settings?.resume_url) window.location.assign(imgUrl(settings.resume_url));
  else toast("Résumé download is coming soon", { description: `Email ${settings?.contact_email || "me"} for the latest copy.` });
};
